/**
 * @desc ToB客户信息-列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.BusinessCustomerListResponseDto>>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/businessCustomer/list`, {
      method: "GET",

      ...options,
    }),
  );
}
